// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component____QqA","slider":"style_slider__I929v","slide":"style_slide__OyKbb","vip-slide":"style_vip-slide__SFSsY"};